// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","183":"524520f0","491":"5227ff75","684":"06f62afa","995":"ee73ee9e"}[chunkId] + ".js";
};